import { render, staticRenderFns } from "./SponsorsSection.vue?vue&type=template&id=ad220b68&scoped=true&"
import script from "./SponsorsSection.vue?vue&type=script&lang=js&"
export * from "./SponsorsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad220b68",
  null
  
)

export default component.exports